const baseRoutes = [
  {
    path: 'menu',
    component: () => import("@/_routes/tabs/menu/Root"),
  },
  {
    path: 'menu/site',
    component: () => import("@/_routes/tabs/menu/Site")
  },
  {
    path: 'menu/armingschedule',
    component: () => import("@/_routes/tabs/menu/ArmingSchedule")
  },
  {
    path: 'menu/partitionarmingschedules',
    component: () => import("@/_routes/tabs/menu/PartitionArmingScheduleList")
  },
  {
    path: 'menu/partitionarmingschedule',
    component: () => import("@/_routes/tabs/menu/PartitionArmingSchedule")
  },
  {
    path: 'menu/bridgesstatus',
    component: () => import("@/_routes/tabs/menu/BridgesStatus")
  },
  {
    path: 'menu/appearance',
    component: () => import("@/_routes/tabs/menu/Appearance")
  },
  {
    path: 'menu/playbackclips',
    component: () => import("@/_routes/tabs/menu/PlaybackClips")
  },
  {
    path: 'menu/emergencycontacts',
    component: () => import("@/_routes/tabs/menu/EmergencyContacts")
  },
  {
    path: 'menu/notifications',
    component: () => import("@/_routes/tabs/menu/Notifications")
  },
  {
    path: 'menu/notifications/partition',
    component: () => import("@/_routes/tabs/menu/PartitionNotifications")
  },
  {
    path: 'menu/bookmarks',
    component: () => import("@/_routes/tabs/menu/Bookmarks")
  },
  {
    path: 'menu/approvalsettings',
    component: () => import("@/_routes/tabs/menu/ApprovalSettings")
  },
  {
    path: 'menu/approvalsettings/type',
    component: () => import("@/_routes/tabs/menu/ApprovalTypeSettings")
  }
]

import membersRoutes              from '@/_routes/tabs/menu/members/_router'
import armingRoutes               from '@/_routes/tabs/menu/arming/_router'
import camerasRoutes             from '@/_routes/tabs/menu/cameras/_router'
const routes = baseRoutes.concat(membersRoutes)
                          .concat(armingRoutes)
                          .concat(camerasRoutes)

export default routes
